'use strict';

(function (ProductImageTag) {
    ProductImageTag["REGULAR"] = "reg";
    ProductImageTag["DETAIL"] = "dtl";
    ProductImageTag["SIZE_RELATION"] = "srl";
    ProductImageTag["INFO_GRAPHIC"] = "inf";
    ProductImageTag["LOOK"] = "lok";
    ProductImageTag["USER_GENERATED_CONTENT"] = "ugc";
    ProductImageTag["MOOD"] = "mod";
    ProductImageTag["ENERGY_EFFICIENCY"] = "eel";
})(exports.ProductImageTag || (exports.ProductImageTag = {}));
var WishListTrackingAction;
(function (WishListTrackingAction) {
    WishListTrackingAction["ADD"] = "add";
    WishListTrackingAction["REMOVE"] = "remove";
})(WishListTrackingAction || (WishListTrackingAction = {}));
(function (ProductSalesType) {
    ProductSalesType["BLACK_FRIDAY"] = "BLACK_FRIDAY";
    ProductSalesType["CYBER_MONDAY"] = "CYBER_MONDAY";
    ProductSalesType["NO_SALES"] = "NO_SALES";
})(exports.ProductSalesType || (exports.ProductSalesType = {}));
var AppBannerValues;
(function (AppBannerValues) {
    AppBannerValues["big"] = "big";
    AppBannerValues["none"] = "none";
    AppBannerValues["small"] = "small";
})(AppBannerValues || (AppBannerValues = {}));
var PdpSizeSelectorNoteValues;
(function (PdpSizeSelectorNoteValues) {
    PdpSizeSelectorNoteValues[PdpSizeSelectorNoteValues["red"] = 0] = "red";
    PdpSizeSelectorNoteValues[PdpSizeSelectorNoteValues["charcoal"] = 1] = "charcoal";
    PdpSizeSelectorNoteValues[PdpSizeSelectorNoteValues["no_note"] = 2] = "no_note";
})(PdpSizeSelectorNoteValues || (PdpSizeSelectorNoteValues = {}));
var PdpLooksInfusionVariant;
(function (PdpLooksInfusionVariant) {
    PdpLooksInfusionVariant[PdpLooksInfusionVariant["none"] = 0] = "none";
    PdpLooksInfusionVariant[PdpLooksInfusionVariant["top"] = 1] = "top";
    PdpLooksInfusionVariant[PdpLooksInfusionVariant["bottom"] = 2] = "bottom";
})(PdpLooksInfusionVariant || (PdpLooksInfusionVariant = {}));
var p100AddToWishlistMobileVariant;
(function (p100AddToWishlistMobileVariant) {
    p100AddToWishlistMobileVariant["control"] = "control";
    p100AddToWishlistMobileVariant["variantA"] = "variantA";
})(p100AddToWishlistMobileVariant || (p100AddToWishlistMobileVariant = {}));
var p100FiltersRedesignVariant;
(function (p100FiltersRedesignVariant) {
    p100FiltersRedesignVariant["control"] = "control";
    p100FiltersRedesignVariant["externalSorting"] = "externalSorting";
    p100FiltersRedesignVariant["rectangleFilters"] = "rectangleFilters";
})(p100FiltersRedesignVariant || (p100FiltersRedesignVariant = {}));
//# sourceMappingURL=types-169d4b99.js.map
